import { env as environment } from '../env';

type Video = {
  id: string;
  poster?: string;
  path: string;
};

export const VIDEOS_URLs: {
  [key: string]: Video;
} = {
  female_intro: {
    id: 'fi',
    poster: '/shared/img/promote/kimi.png',
    path: `${environment.baseURL}/images/question-answer/introduction_to_fantaz_female_version.mp4`,
  },
  male_intro: {
    id: 'mi',
    poster: '/shared/img/promote/dustin.png',
    path: `${environment.baseURL}/images/question-answer/introduction_to_fantaz_male_version.mp4`,
  },
  introduction: {
    id: 'introduction',
    poster: '/shared/img/profit/video-poster.svg',
    path: `${environment.baseURL}/images/question-answer/introduction.mp4`,
  },
  zPlayer: {
    id: 'introduction',
    poster: '/shared/img/profit/know-about-zplayers.webp',
    path: `${environment.baseURL}/images/question-answer/zplayer.mp4`,
  },
  zbo: {
    id: 'introduction',
    poster: '/shared/img/profit/become-zbo.webp',
    path: `${environment.baseURL}/images/question-answer/zbo.mp4`,
  },
};

/**
 * This is the minimum number of passes to consider as unlimited(for button text purposes).
 */
export const UNLIMITED_PASSES = 5001;

export const ONBOARDING = {
  IN_PROGRESS: 'ONBOARDING_IN_PROGRESS',
};

export const TSEVO_MESSAGE_STATUS_MAP: {
  [key: string]: {
    name: string;
    textContent: string;
    button: { content: string; action: string };
  };
} = {
  UNKNOWN_ERROR: {
    name: 'Unknown Error',
    textContent: 'Our payment processor is facing some unexpected issues.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  VELOCITY_REACHED: {
    name: 'Velocity Fraud Detection',
    textContent: 'Payment method limit reached.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  TRANSACTION_IN_PROCESS: {
    name: 'Transaction in process',
    textContent: 'Transaction already processed.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  TSEVO_ERROR: {
    name: 'TSEVO Error',
    textContent: 'Our payment processor is facing some unexpected issues.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  SESSION_IN_PROGRESS: {
    name: 'Session in Progress',
    textContent: 'Payment Session in progress.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  SESSION_TIMEOUT: {
    name: 'Session Timeout',
    textContent: 'Maximum allowed time exceeded to complete the deposit.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  SESSION_INELIGIBLE: {
    name: 'Session Ineligible',
    textContent: 'No information provided that can be successfully validated.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  SESSION_INCOMPLETE: {
    name: 'Session Incomplete',
    textContent: 'The deposit session did not completed.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  AVS_UNAVAILABLE: {
    name: 'AVS Unavailable',
    textContent:
      'No address provided or credit card does not support address verification service.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  AVS_PARTIAL_MATCH: {
    name: 'AVS Partial Match',
    textContent: 'Either street address or zip code matched.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  AVS_NO_MATCH: {
    name: 'AVS No Match',
    textContent: 'None of the addresses matched.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  CCV_UNAVAILABLE: {
    name: 'CCV Unavailable',
    textContent: 'No CCV provided or credit card does not support CCV.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  CCV_NO_MATCH: {
    name: 'CCV No Match',
    textContent: 'The CCV did not match.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  PAYMENT_FAILED: {
    name: 'Payment failed',
    textContent: 'No details available at this moment.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  PAYOUT_FAILED: {
    name: 'Withdrawal failed',
    textContent: 'No details available at this moment.',
    button: {
      content: 'Try Again',
      action: 'tryAgain',
    },
  },
  INELIGIBLE: {
    name: 'Session Ineligible',
    textContent:
      'Please check if your card details were entered correctly. Some cards may not support address verification (AVS) or CVV checks.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_UNAVAILABLE_CVV_UNAVAILABLE: {
    name: 'Session Ineligible',
    textContent:
      'Please check if your card details were entered correctly. Some cards may not support address verification (AVS) or CVV checks.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_UNAVAILABLE_CVV_NO_MATCH: {
    name: 'Session Ineligible',
    textContent:
      'Please double-check the CVV and  the address you entered. Some cards might not support address verification (AVS).',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_UNAVAILABLE_CVV_MATCH: {
    name: 'No address provided',
    textContent:
      'Please make sure you entered your  address. Some  credit cards do not support address verification (AVS).',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_NO_MATCH_CVV_UNAVAILABLE: {
    name: 'None of the address matched',
    textContent: `Your address doesn't seem to be correct. Also, please ensure you enter the CVV from your card.`,
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_NO_MATCH_CVV_NO_MATCH: {
    name: 'None of the address matched',
    textContent: `The address and CVV you've entered don't match. Please re-enter your card details and try again or contact our Support Team.`,
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_NO_MATCH_CVV_MATCH: {
    name: 'None of the address matched',
    textContent:
      'Your address does not match. Please correct it and try again or contact our Support Team.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_PARTIAL_MATCH_CVV_UNAVAILABLE: {
    name: 'Street address or postal code matched',
    textContent:
      'Please double-check your address, enter your CVV, and try again or contact our Support Team.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_PARTIAL_MATCH_CVV_NO_MATCH: {
    name: 'Street address or postal code matched',
    textContent:
      'Please double-check the address and CVV you entered and try again or contact our Support Team.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_PARTIAL_MATCH_CVV_MATCH: {
    name: 'Street address or postal code matched',
    textContent:
      'Please double-check your address and try again or contact our Support Team.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_EXACT_MATCH_CVV_UNAVAILABLE: {
    name: 'Street address and postal code matched',
    textContent:
      'Please try again and enter your CVV or contact our Support Team.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  AVS_EXACT_MATCH_CVV_NO_MATCH: {
    name: 'Street address and postal code matched',
    textContent:
      'The CVV code entered does not match. Please check it and try again or contact our Support Team.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  DEPOSIT_MIN_AMOUNT_LIMIT: {
    name: 'Deposit amount limit',
    textContent: 'The deposit amount is below the minimum required.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  DEPOSIT_MAX_AMOUNT_LIMIT: {
    name: 'Deposit amount limit',
    textContent: 'The deposit amount reached the maximum allowed.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  WITHDRAWAL_MIN_AMOUNT_LIMIT: {
    name: 'Withdrawal amount limit',
    textContent: 'The withdrawal amount is below the minimum required.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  WITHDRAWAL_MAX_AMOUNT_LIMIT: {
    name: 'Withdrawal amount limit',
    textContent:
      'You have reached the max withdraw limit. For more info or assistance, please contact customer support or try again later in 24 hours.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
  WITHDRAWAL_MAX_REQUEST_LIMIT: {
    name: 'Withdrawal requests exceeds limit',
    textContent:
      'You have reached the max withdraw limit. For more info or assistance, please contact customer support or try again later in 24 hours.',
    button: {
      content: 'Contact Customer Support',
      action: 'contactCustomerSupport',
    },
  },
};

export const AVS_RESULT_CODE = {
  // No address provided or credit card does not support AVS.
  UNAVAILABLE: 'Unavailable',

  // None of the address matched.
  NO_MATCH: 'NoMatch',

  // Either street address or postal code matched.
  PARTIAL_MATCH: 'PartialMatch',

  // Both street address and postal code matched.
  EXACT_MATCH: 'ExactMatch',
};

export const CVV_RESULT_CODE = {
  // No CVV provided or credit card does not support CVV.
  UNAVAILABLE: 'Unavailable',

  // The CVV did not match.
  NO_MATCH: 'NoMatch',

  // The CVV matched.
  MATCH: 'Match',
};

export const SUPPORTED_CREDIT_CARDS = [
  'americanexpress',
  'dinersclub',
  'discover',
  'echeck',
  'jcb',
  'maestro',
  'mastercard',
  'visa',
  'unknown',
];

export const SUPPORTED_CREDIT_CARDS_DARK = [
  'dinersclub',
  'visa',
  'discover',
  'unknown',
];

// TODO: In the future change it by a translation config
// and also the transaction status mechanism
export const TRANSACTION_TYPE_LABEL_MAP = {
  REQUEST_WITHDRAW: 'Withdrawal request',
  DECLINED_WITHDRAW: 'Denied Withdrawal Request',
  WITHDRAW: 'Withdraw',
  CANCELED_WITHDRAWAL_REQUEST: 'Canceled Withdrawal Request',
  EXPIRED_WITHDRAWAL_REQUEST: 'Expired Withdrawal Request',
  DEPOSIT: 'Deposit',
  ZBO_FEES: 'ZBO Fees',
  PRIZE: 'Prize',
  ZBO_REFERRAL: 'ZBO Referral',
  GAME: 'Tournament Entry Fees',
  FANTAZ_PRODUCT: 'FANTAZ_PRODUCT',
  FANTAZ_CORPORATE: 'FantaZ Corporate',
  HOST_FEES_SHARE: 'Host Fees Share',
  SPONSOR_FEES_SHARE: 'Sponsor Fees Share',
  DEVELOPER_FEES_SHARE: 'Dev Fees Share',
  TOURNAMENT_MISC: 'Tournament Misc',
  TRANSACTION_FEES: 'Incoming Transaction Fees',
  CUSTOMER_SATISFACTION_TOKENS: 'Customer Satisfaction Tokens',
  OUTGOING_TRANSACTION_FEES: 'Outgoing Transaction Fees',
  MARKETING_TOKENS: 'Marketing Tokens',
  PROMOTIONAL_BONUS: 'Promotional Bonus',
  TOURNAMENT_REFUNDS: 'Tournament Refund',
  PRIOR_PLATFORM_BALANCES: 'Prior Platform Balances',
  FREE_ZBO_FEES: 'Free ZBO Fees',
  RETURNED_TOURNAMENT_ENTRY_FEE: 'Returned Tournament Entry Fee',
  CHARITIES_FEES: 'Charities Fees',
  AGENT_FEES: 'Agent Fees',
  TOURNAMENT_PASS: 'Tournament Pass',
  RETURNED_TOURNAMENT_PASS: 'Returned Tournament Pass',
  ZBO_BONUS: 'ZBO Bonus',
  TOURNAMENT_DISTRIBUTION_ADJUSTMENT: 'Tournament Distribution Adjustment',
  ZBO_FEES_REFUND_ADMIN: 'ZBO Fees Refund-Admin',
  TOURNAMENT_REFUND_ADMIN: 'Tournament Refund-Admin',
  ZBO_BONUS_ADMIN: 'ZBO Bonus-Admin',
  CASH_PRIZE_PAYOUT: 'Cash prize payout',
};

export const TransactionType = {
  ZBO_REFERRAL: 'ZBO_REFERRAL',
  PRIZE: 'PRIZE',
  REQUEST_WITHDRAW: 'REQUEST_WITHDRAW',
  APPROVED_WITHDRAW: 'APPROVED_WITHDRAW',
  TOURNAMENT_ENTRY_FEES: 'GAME',
  RETURNED_TOURNAMENT_ENTRY_FEE: 'RETURNED_TOURNAMENT_ENTRY_FEE',
  TOURNAMENT_PASS: 'TOURNAMENT_PASS',
  DEPOSIT: 'DEPOSIT',
  TRANSACTION_FEES: 'TRANSACTION_FEES',
  WITHDRAW: 'WITHDRAW',
  DECLINED_WITHDRAW: 'DECLINED_WITHDRAW',
  CANCELED_WITHDRAWAL_REQUEST: 'CANCELED_WITHDRAWAL_REQUEST',
  EXPIRED_WITHDRAWAL_REQUEST: 'EXPIRED_WITHDRAWAL_REQUEST',
  LOAN: 'LOAN',
  LOAN_REPAYMENT: 'LOAN_REPAYMENT',
};

export const TransactionStatus = [
  { type: 'NONE', name: 'None' },
  { type: 'APPROVED', name: 'Approved' },
  { type: 'DENIED', name: 'Denied' },
  { type: 'FAILED', name: 'Failed' },
  { type: 'CANCELED', name: 'Canceled' },
  { type: 'REQUESTED', name: 'Requested' },
  { type: 'PROCESSING', name: 'Processing' },
  { type: 'COMPLETED', name: 'Completed' },
  { type: 'EXPIRED', name: 'Expired' },
];

export const TRANSACTION_STATUS_LABEL_MAP = {
  REQUESTED: 'Withdrawal requested',
  APPROVED: 'Withdrawal approved',
  FAILED: 'Transaction error',
  PROCESSING: 'Processing transaction',
  COMPLETED: 'Withdrawal completed',
  DENIED: 'Transaction denied',
  CANCELED: 'Withdrawal canceled',
  EXPIRED: 'Withdrawal expired',
  REFUND_LOAN: `Refund <b class="text-color--primary">{amountFormatted} USD</b> in advance.`,
  DISCOUNT_LOAN: `Payoff <b class="text-color--primary">{amountFormatted} USD</b> wallet’s negative balance.`,
  LOAN: `Pending ACH deposit. You were approved <b class="text-color--primary">{amountFormatted} USD</b> in advance.`,
};

export const TRANSACTION_STATUS_TOOLTIP_MAP = {
  REQUESTED: 'Your withdrawal is pending for approval.',
  APPROVED: 'Your withdrawal has been approved.',
  FAILED:
    'A transaction error has occurred, please try again or contact customer support.',
  PROCESSING: `The transaction is being processed by the bank's system.`,
  COMPLETED: `Your transaction has been successfully completed.`,
  DENIED:
    'FantaZ has denied this withdrawal. Contact customer support for further information.',
  CANCELED: 'You have canceled this operation.',
  EXPIRED: 'The 7-day period to complete this withdrawal has expired.',
};

export const TRANSACTION_STATUS_INDICATOR = {
  APPROVED: 'successful',
  COMPLETED: 'completed',
  REQUESTED: 'warning',
  PROCESSED: 'warning',
  PROCESSING: 'warning',
  FAILED: 'error',
  DENIED: 'error',
  CANCELED: 'canceled',
  EXPIRED: 'default',
};

export const PAYMENT_PROCESSOR_ERROR = {
  TRANSACTION_NOT_FOUND: 'TRANSACTION_NOT_FOUND',
  WALLET_PROCESSOR_ERROR: 'WALLET_PROCESSOR_ERROR',
  DEPOSIT_MIN_AMOUNT_LIMIT: 'DEPOSIT_MIN_AMOUNT_LIMIT',
  DEPOSIT_MAX_AMOUNT_LIMIT: 'DEPOSIT_MAX_AMOUNT_LIMIT',
  WITHDRAWAL_MIN_AMOUNT_LIMIT: 'WITHDRAWAL_MIN_AMOUNT_LIMIT',
  WITHDRAWAL_MAX_AMOUNT_LIMIT: 'WITHDRAWAL_MAX_AMOUNT_LIMIT',
  WITHDRAWAL_MAX_REQUEST_LIMIT: 'WITHDRAWAL_MAX_REQUEST_LIMIT',
};

export const TRANSACTION_CATEGORY = {
  /**0 */
  CREDIT: 0,
  //**1 */
  DEBIT: 1,
  //**2 */
  WAIVED: 2,
  //**3 */
  WITHDRAW: 3,
};
